//@ts-check
import request from './request';
/**
 * @type {import('./types').SendFeedbackEmailFunction}
 */

export default (function (email) {
  return request({
    method: "POST",
    url: "/backend/tickets",
    data: email,
    contentType: "multipart"
  });
});